<template>
  <div class="Bayonot">
    <div v-for="itemsh in data.doctor">
      <div id="my-node">
        <div>
          <PechatLogo />
        </div>
        <div class="BayonotChild">
          <div style="width: 100%;">
            <PechatBemorData 
              :datas="data"
              :date="itemsh.date_doctor"
              :name="itemsh.reg_doctor_category[0].name"
              :doctor_name="itemsh.doctor.name"
              />
          </div>
        </div>
        <div>
          <div>
            <div class="ins-name"> 
              <div
                class="vueTextEditor"
                v-for="(itemText, indText) in JSON.parse(itemsh.text)"
                :key="indText"
                :style="indText ? 'padding-top: 30px;' : ''"
              >
                <div style="border: 1px solid #000">
                  <ckeditor
                    v-if="itemsh.table_type"
                    :style="'width: 917px;'"
                    v-model="itemText[`${itemText.key}`]"
                    :editor="editor"
                    :config="editorConfig"
                  >
                  </ckeditor>
                  <vue-editor
                    v-else
                    style="width: 917px"
                    v-model="itemText[`${itemText.key}`]"
                  />
                </div>
                <div class="table-style" v-if="itemsh.registration_recipe.length">
                    <table class="table table-sm table-bordered">
                        <thead id="head">
                          <tr>
                            <th>№</th>
                            <th>Дори</th>
                            <th>Қўллалиниши</th>
                          </tr>
                        </thead>
                        <tbody class="BayonotThead">
                          <tr v-for="(item, index) in itemsh.registration_recipe">
                            <td style="width: 40px;">{{ index+1 }}</td>
                            <td>{{ item.pill.name }}</td>
                            <td>
                                <div class="multiline-text">
                                    {{ item.comment }}
                                </div>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                  <PechatFooter />
                </div>
                <!-- <div v-if="itemsh.a4_images.length > 0">
                  <h2>Rasmlar</h2>
                  <div class="pictures">
                    <div class="grid-item" v-for="(img, inx) in itemsh.a4_images">
                      <img
                      class="fit-picture"
                      :src="BASE_URL + img.image_name"
                      />
                    </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PechatLogo from "./Components/PechatLogo.vue"
import PechatBemorData from "./Components/PechatBemorData.vue";
import PechatFooter from "./Components/PechatFooter.vue"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  name: "Print",
  components:{
    PechatLogo,
    PechatBemorData,
    PechatFooter
  },
  data() {
    return {
      data: {},
      editor: ClassicEditor,
      datasort: {},
      Dorilar: []
      // weekdays: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    };
  },
  
  created: function() {
    this.data = JSON.parse(localStorage.getItem("Bayonot"));
  },
  methods: {
    
  },
  mounted() {
    localStorage.removeItem("Bayonot");
    window.print();
    setTimeout(() => {
      this.$router.push({ path: "/user" });
      window.close();
    }, 3000);
  }
};
</script>

<style lang="scss">
.pictures {
  display: grid;
  grid-template-columns: 45% 45%;
  gap: 20px;
}

.jadval{
  font-size: 20px;
  display: flex;
  justify-content: space-between;
}
.table-style{
    padding-top: 20px;
    padding-bottom: 20px;
}
#head th{
  background: #d6d5d5 !important;
  color: #000 !important;
  border: 1px solid #000 !important;
}
.BayonotThead td{
  border: 1px solid #000 !important;
  color: #000 !important;
  font-size: 16px;
  font-weight: 500;
}
.multiline-text {
  white-space: pre-line;
}
.BayonotChild {
  margin-top: 20px;
  width: 100%;
  /* border: none !important; */
}
// .vue-editor-text{
//   width: 960px;
// }
.vueTextEditor {
  // page-break-inside: avoid;
  // page-break-before: auto;
}
.vueTextEditor .quillWrapper {
  border: none !important;
}
.vueTextEditor .quillWrapper #quill-container {
  /* font-size: 18px !important; */
  border: none !important;
}
.vueTextEditor .ql-toolbar {
  display: none;
}
.vueTextEditor .quillWrapper #quill-container .ql-editor{
  min-height: 50px !important;
}
.ql-editor{
  color: #000;
}
.vueTextEditor .ql-editor {
    // text-transform: uppercase;
    font-family: 'Times New Roman', Times, serif !important;
    // color: #000;
    p{
        font-size: 20pt;
        line-height: 26px;
    }
    strong {
        font-weight: 700 !important;
    }
    u{
      font-weight: 700 !important;
    }
    h1, h2, h3, h4, h5, h6 {
        // text-transform: uppercase;
        font-family: 'Times New Roman', Times, serif !important;
        color: #000;
        // font-size: 20px;
        font-weight: 400;
    }
    h1{
        font-size: 26pt !important;
        line-height: 32px;
    }
    h2{
        font-size: 24pt !important;
        line-height: 30px;
    }
    h3{
        font-size: 22pt !important;
        line-height: 28px;
    }
    h4{
        font-size: 18pt !important;
        line-height: 24px;
    }
    h5{
        font-size: 16pt !important;
        line-height: 22px;
    }
    h6{
        font-size: 14pt !important;
        line-height: 20px;
    }
}
.ck.ck-editor{
    width: 917px;
}
.ck-editor__editable_inline{
    height: 1000px !important;
}
.ck-editor__editable {
    p{
        font-size: 20pt;
        line-height: 26px;
        margin: 0px !important;
        padding: 0px !important;
        font-family: 'Times New Roman', Times, serif;
    }
    strong {
        font-weight: 700 !important;
    }
    u{
      font-weight: 700 !important;
    }
    h1, h2, h3, h4, h5, h6 {
        // text-transform: uppercase;
        font-family: 'Times New Roman', Times, serif !important;
        // color: #000;
        // font-size: 20px;
        font-weight: 400;
    }
    h1{
        font-size: 26pt !important;
        line-height: 32px;
    }
    h2{
        font-size: 24pt !important;
        line-height: 30px;
    }
    h3{
        font-size: 22pt !important;
        line-height: 28px;
    }
    h4{
        font-size: 18pt !important;
        line-height: 24px;
    }
    h5{
        font-size: 16pt !important;
        line-height: 22px;
    }
    h6{
        font-size: 14pt !important;
        line-height: 20px;
    }
}
.ck-content .table table td{
    padding: 0px 5px !important;
    text-align: center;
    font-size: 11pt;
}
.ck-content .table table th{
    padding: 0px 5px !important;
    text-align: center !important;
    font-size: 11pt;
}
.ck-editor__top {
  display: none !important;
}
.ck.ck-editor__main>.ck-editor__editable{
  border: none !important;
}
// .ql-editor p{
//   font-size: 18px;
// }
.ins-name {
  /* page-break-inside: avoid; */
  /* list-style: none; */
  padding: 0;
  margin: 10px 0px;
  /* border: 4px solid red; */
}
.Bayonot {
  width: 959px;
  padding: 20px;
  margin: 0px auto;
}
#my-node{
  /* page-break-inside: unset; */
  list-style: none;
  // page-break-after: always;
  page-break-inside: always;
}
.logo-matn {
  position: relative;
  height: 150px;
  width: 300px;
  /* border: 1px solid red; */
}
.logo-info {
  position: absolute;
  bottom: 0px;
  display: flex;
  font-size: 16px;
  font-weight: 700;
}
</style>